module.exports = __webpack_public_path__ + "static/gtocxresult-cfd6e02843055f0c686b4cc37d479a5d.gif";